// packages/frontend/src/lib/next-yandex-metrica/hooks/useTrackRouteChange.ts

import { usePathname } from "next/navigation";
import { Router } from "next/router";
import { useEffect } from "react";

import { NextRouter } from "../lib/types/router";
import { ym } from "../lib/ym";

declare global {
  interface Window {
    ymab?: (...args: any[]) => void;
  }
}

export const useTrackRouteChange = ({
  tagID,
  router,
}: {
  tagID: number | null;
  router: NextRouter;
}) => {
  const pathname = usePathname();

  // Pages router: listen to routeChangeComplete
  useEffect(() => {
    if (!tagID || router === "app") return;

    const handleRouteChange = (url: URL): void => {
      ym(tagID, "hit", url.toString());

      if (typeof window !== "undefined" && typeof window.ymab === "function") {
        window.ymab(`metrika.${tagID}`, "init");
      }
    };

    // initial page load
    if (typeof window !== "undefined" && typeof window.ymab === "function") {
      window.ymab(`metrika.${tagID}`, "init");
    }

    Router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      Router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [tagID, router]);

  // App router case (if you ever use it)
  useEffect(() => {
    if (!tagID || router === "pages") return;

    ym(tagID, "hit", pathname);

    if (typeof window !== "undefined" && typeof window.ymab === "function") {
      window.ymab(`metrika.${tagID}`, "init");
    }
  }, [tagID, router, pathname]);
};
